import { MarkerF } from '@react-google-maps/api';

const USER_LOCATION_ICON =
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <circle
        cx="24"
        cy="24"
        r="20"
        fill="#2563eb"
        fill-opacity="0.10"
      />

      <circle
        cx="24"
        cy="24"
        r="14"
        fill="#2563eb"
        fill-opacity="0.18"
        stroke="#60a5fa"
        stroke-opacity="0.35"
        stroke-width="1"
      />

      <circle
        cx="24"
        cy="24"
        r="8"
        fill="#2563eb"
        stroke="#ffffff"
        stroke-width="3"
      />

      <circle
        cx="21.5"
        cy="21.5"
        r="2"
        fill="#93c5fd"
      />
    </svg>
  `)}`;

function UserLocationMarker({
  location,
  streetViewActive = false
}) {
  if (
    !location ||
    streetViewActive
  ) {
    return null;
  }

  const latitude =
    Number(location.lat);

  const longitude =
    Number(location.lng);

  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude)
  ) {
    return null;
  }

  return (
    <MarkerF
      position={{
        lat: latitude,
        lng: longitude
      }}
      title="Mi ubicación"
      options={{
        clickable: false,
        optimized: true,
        zIndex: 999998,

        icon: {
          url: USER_LOCATION_ICON,

          scaledSize:
            new window.google.maps.Size(
              48,
              48
            ),

          anchor:
            new window.google.maps.Point(
              24,
              24
            )
        }
      }}
    />
  );
}

export default UserLocationMarker;